
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 58 58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.75 30.813H5.437a3.625 3.625 0 01-3.625-3.625V5.438a3.625 3.625 0 013.625-3.625h29a3.625 3.625 0 013.626 3.625V21.75m9.253 2.815l6.25 3.123a1.813 1.813 0 002.621-1.622V6.56a1.812 1.812 0 00-2.622-1.622l-6.25 3.123a3.624 3.624 0 00-2.002 3.243v10.02a3.625 3.625 0 002.003 3.242v0zM27.188 45.313a10.875 10.875 0 1021.75 0 10.875 10.875 0 00-21.75 0v0z","stroke":"#3B3B3B","stroke-width":"3.625","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M38.063 44.406a.906.906 0 100 1.813.906.906 0 000-1.813z","stroke":"#3B3B3B","stroke-width":"3.625","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    